import React from "react";

/**
 * SourceBadge — small pill shown on rows imported from an external source
 * (e.g. Fireflies meeting ingest).
 */
const SourceBadge = ({ source, className = "" }) => {
  if (!source) return null;
  const map = {
    fireflies: { label: "FIREFLIES", color: "#FF9E5B" },
    todoist: { label: "TODOIST", color: "#00E5FF" },
    manual: null,
  };
  const cfg = map[source.toLowerCase?.() || source];
  if (!cfg) return null;
  return (
    <span
      data-testid={`source-badge-${source}`}
      className={`op-source-badge ${className}`}
      style={{
        color: cfg.color,
        borderColor: `${cfg.color}55`,
        background: `${cfg.color}0f`,
      }}
    >
      {cfg.label}
    </span>
  );
};

export default SourceBadge;
